import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, from, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UiUtilityService } from '../ui-utility.service';
import { finalize } from 'rxjs/operators';
import { ApiResponseModel } from './api-response.model';
import { LoggerService } from '../log.service';
import { CapacitorHttp, HttpOptions, HttpResponse } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { BackgroundStateService } from '../background.service';
import {  tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataService<T> {
  readonly headers: any = { headers: { 'Content-Type': 'application/json' } };
  // private readonly apiURL: string = 'assets/data/data1.json';

  constructor(
    public http: HttpClient,
    private uiUtilityService: UiUtilityService,
    private loggerService: LoggerService,
    private platform: Platform,
    private bg: BackgroundStateService
  ) { }

private isAlertVisible: boolean = false;
handleError = (error: HttpErrorResponse) => {
  const errorLog = `${error.url}-${error.status}-${error.statusText}`;
  this.loggerService.saveErrorToFile(errorLog);

  let message = error?.error?.data;
  let title = 'Error';

  // Explicit check for 401
  if (error.status === 401) {
    message = 'For your security, please sign back in to continue.';
  } else if (error.status === 0 || !navigator.onLine) {
    title = '';
    message = 'Service temporarily interrupted.';
  } else if (!message) {
    title = '';
    message = 'Service temporarily interrupted.';
  }

  // Debug: Is the lock blocking the 401?
  if (this.isAlertVisible) {
    console.warn('Alert BLOCKED because isAlertVisible is TRUE!');
    return throwError(() => error);
  }

  this.isAlertVisible = true;

  // Show the alert directly without depending on dismissErrorAlert resolving first
  this.uiUtilityService.showAlert(`${message}`, title)
    .then(() => {
      console.log('Alert shown and closed by user');
    })
    .catch((err) => {
      console.error('Error while showing alert:', err);
    })
    .finally(() => {
      this.isAlertVisible = false;
    });

  return throwError(() => error);
};
  isMobile(): boolean {
    return false; //this.platform.is('hybrid');
  }

  private async httpNative<T>(url: string, props?: any): Promise<T> {
    const options: HttpOptions = {
      url,
      ...props
    };
    const response: HttpResponse = await CapacitorHttp.request(options);
    return response.data as T;
  }

getData<T>(url: string, params = {}): Observable<ApiResponseModel<T>> {
  const fullUrl: string = environment.baseUrl + url;

  if (this.isMobile()) {
    console.log('ALOK ALOK ALOK');
    return from(this.httpNative<ApiResponseModel<T>>(fullUrl, { method: 'GET', params })).pipe(
      catchError((err) => {
        console.log('>>> Mobile catchError hit:', err);
        return this.handleError(err);
      }),
      finalize(() => this.uiUtilityService.closeLoader())
    );
  } else {
    console.log('ALOK2 ALO2K AL2OK - Requesting:', fullUrl);
    return this.http.get<ApiResponseModel<T>>(fullUrl, { params }).pipe(
      tap({
        next: (res) => console.log('>>> HTTP Success:', res),
        error: (err) => console.log('>>> HTTP Error caught in tap:', err)
      }),
      catchError((err) => {
        console.log('>>> HTTP catchError hit:', err);
        return this.handleError(err);
      }),
      finalize(() => {
        console.log('>>> HTTP finalize triggered');
        this.uiUtilityService.closeLoader();
      })
    );
  }
}
  getBlob(url: string, params = {}): Observable<any> {
    const fullUrl: string = environment.baseUrl + url;
    if (this.isMobile()) {
      return from(this.httpNative(fullUrl, { method: 'GET', params, responseType: 'blob' })).pipe(
        catchError(this.handleError),
        finalize(() => this.uiUtilityService.closeLoader())
      );
    } else {
      return this.http.get(fullUrl, { ...params, responseType: 'blob' }).pipe(
        catchError(this.handleError),
        finalize(() => this.uiUtilityService.closeLoader())
      );
    }
  }

  post<T>(
    url: string,
    payload: any,
    headers: any = { headers: { 'Content-Type': 'application/json' } }
  ): Observable<any> {
    const fullUrl: string = environment.baseUrl + url;
    if (this.isMobile()) {
      return from(this.httpNative<T>(fullUrl, { method: 'POST', data: payload, headers: headers.headers })).pipe(
        catchError(this.handleError),
        finalize(() => this.uiUtilityService.closeLoader())
      );
    } else {
      return this.http.post<T>(fullUrl, payload, headers)
        .pipe(catchError(this.handleError), finalize(() => this.uiUtilityService.closeLoader()));
    }
  }

  put<T>(url: string, payload: any): Observable<any> {
    const headers: any = { headers: { 'Content-Type': 'application/json' } };
    const fullUrl: string = environment.baseUrl + url;
    if (this.isMobile()) {
      return from(this.httpNative<T>(fullUrl, { method: 'PUT', data: payload, headers: headers.headers })).pipe(
        catchError(this.handleError),
        finalize(() => this.uiUtilityService.closeLoader())
      );
    } else {
      return this.http
        .put<T>(fullUrl, payload, headers)
        .pipe(catchError(this.handleError), finalize(() => this.uiUtilityService.closeLoader()));
    }
  }

  delete<T>(
    url: string,
    payload: any
  ): Observable<any> {
    const headers: any = {
      headers: { 'Content-Type': 'application/json' },
      body: payload,
    };
    const fullUrl: string = environment.baseUrl + url;
    if (this.isMobile()) {
      return from(this.httpNative<T>(fullUrl, { method: 'DELETE', headers: headers.headers })).pipe(
        catchError(this.handleError),
        finalize(() => this.uiUtilityService.closeLoader())
      );
    } else {
      return this.http
        .delete<T>(fullUrl, headers)
        .pipe(catchError(this.handleError), finalize(() => this.uiUtilityService.closeLoader()));
    }
  }
}
